export var PRIVILEGES;
(function (PRIVILEGES) {
    PRIVILEGES["SERVICEDESK_VIEW"] = "SERVICEDESK_VIEW";
    PRIVILEGES["SERVICEDESK_SUBMIT"] = "SERVICEDESK_SUBMIT";
    PRIVILEGES["ROSTER_MANAGE_USERS"] = "ROSTER_MANAGE_USERS";
    PRIVILEGES["ROSTER_MANAGE_SPACE_CATEGORIES"] = "ROSTER_MANAGE_SPACE_CATEGORIES";
    PRIVILEGES["ACTIVATION_CODE_ADMIN"] = "ACTIVATION_CODE_ADMIN";
    PRIVILEGES["BASIC_EMPLOYEE_ACCESS"] = "BASIC_EMPLOYEE_ACCESS";
    PRIVILEGES["COMPANY_PROFILE_ADMIN"] = "COMPANY_PROFILE_ADMIN";
    PRIVILEGES["COMPANY_VIEW_CUSTOMER"] = "COMPANY_VIEW_CUSTOMER";
    PRIVILEGES["COMPANY_VIEW_EMPLOYEE"] = "COMPANY_VIEW_EMPLOYEE";
    PRIVILEGES["CREATE_USER_ACCOUNT"] = "CREATE_USER_ACCOUNT";
    PRIVILEGES["ROSTER_MANAGE_COMPANY"] = "ROSTER_MANAGE_COMPANY";
    PRIVILEGES["ROSTER_VIEW_ALL"] = "ROSTER_VIEW_ALL";
    PRIVILEGES["ROSTER_VIEW_COMPANY"] = "ROSTER_VIEW_COMPANY";
    PRIVILEGES["ROSTER_VIEW_SERVICES"] = "ROSTER_VIEW_SERVICES";
    PRIVILEGES["SERVICEDESK_EMPLOYEE_CREATE"] = "SERVICEDESK_EMPLOYEE_CREATE";
    PRIVILEGES["SWITCH_USER_DEMO"] = "SWITCH_USER_DEMO";
    PRIVILEGES["VIDEO_ADMIN"] = "VIDEO_ADMIN";
    PRIVILEGES["VIDEO_FACE_NAME_UPDATE"] = "VIDEO_FACE_NAME_UPDATE";
    PRIVILEGES["POWER_VIEW_GRAPH"] = "POWER_VIEW_GRAPH";
    PRIVILEGES["ONLINE_ORDERING"] = "ONLINE_ORDERING";
    PRIVILEGES["ONLINE_ORDERING_SUBMIT"] = "ONLINE_ORDERING_SUBMIT";
    PRIVILEGES["MAPS_ADMIN"] = "MAPS_ADMIN";
    PRIVILEGES["ROSTER_MANAGE_CRITICAL_CONTACTS"] = "ROSTER_MANAGE_CRITICAL_CONTACTS";
    PRIVILEGES["ROSTER_MANAGE_SITES"] = "ROSTER_MANAGE_SITES";
    PRIVILEGES["API_SERVICENOW_UPDATE"] = "API_SERVICENOW_UPDATE";
    PRIVILEGES["ROSTER_BADGEHOLDER_REPORT"] = "ROSTER_BADGEHOLDER_REPORT";
    PRIVILEGES["ROSTER_USER_ONSITE_REPORT"] = "ROSTER_USER_ONSITE_REPORT";
    PRIVILEGES["ROSTER_EVENTLOG_REPORT"] = "ROSTER_EVENTLOG_REPORT";
    PRIVILEGES["ROSTER_VISITORS_ACCESS_LOG_REPORT"] = "ROSTER_VISITORS_ACCESS_LOG_REPORT";
    PRIVILEGES["PROFILE_USER_AND_BADGE_MANAGEMENT"] = "PROFILE_USER_AND_BADGE_MANAGEMENT";
    PRIVILEGES["PROFILE_VISITOR_RESERVATION"] = "PROFILE_VISITOR_RESERVATION";
    PRIVILEGES["PROFILE_USER_AND_BADGE_VIEW_ONLY"] = "PROFILE_USER_AND_BADGE_VIEW_ONLY";
    PRIVILEGES["PROFILE_APP_AVAILABILITY"] = "PROFILE_APP_AVAILABILITY";
})(PRIVILEGES || (PRIVILEGES = {}));
export var PRIVILEGE_CONDITIONS;
(function (PRIVILEGE_CONDITIONS) {
    PRIVILEGE_CONDITIONS["OR"] = "OR";
    PRIVILEGE_CONDITIONS["AND"] = "AND";
})(PRIVILEGE_CONDITIONS || (PRIVILEGE_CONDITIONS = {}));
